// extracted by mini-css-extract-plugin
export default {"brandPromo":"RF-z","carousel":"SF-z"};